// สุ่มแบบมี seed: seed เดิม + ข้อมูลเดิม = ชีวิตเดิมทุกครั้ง (docs/PLAN.md ข้อ 6)
// ใช้ mulberry32 เก็บสถานะเป็นตัวเลข 32 บิตตัวเดียว จึงบันทึกลงสถานะของชีวิตได้

/** แปลง seed ที่เป็นข้อความเป็นสถานะเริ่มต้น 32 บิต (cyrb53 แบบย่อ) */
export function hashSeed(seed: string): number {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < seed.length; i++) {
    const ch = seed.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  return h1 >>> 0;
}

export class Rng {
  constructor(public state: number) {}

  /** 0 ≤ ค่า < 1 */
  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** จำนวนเต็มตั้งแต่ min ถึง max (รวมทั้งสองค่า) */
  int(min: number, max: number): number {
    return min + Math.floor(this.next() * (max - min + 1));
  }

  chance(p: number): boolean {
    return this.next() < p;
  }

  /** เลือกตามน้ำหนัก คืน index */
  weightedIndex(weights: readonly number[]): number {
    const total = weights.reduce((sum, w) => sum + w, 0);
    let r = this.next() * total;
    for (let i = 0; i < weights.length; i++) {
      r -= weights[i];
      if (r < 0) return i;
    }
    return weights.length - 1;
  }
}

/** seed สำหรับชีวิตใหม่ สั้นพอใส่ในลิงก์แชร์ได้ */
export function randomSeed(): string {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(36).padStart(2, "0")).join("").slice(0, 10);
}
